import {Checkbox, Collapse, Form, Input, TreeSelect, message, Modal} from 'antd';
import React, {PureComponent} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {modal} from 'icsoc-antd-ex';
import newRoleActions from 'Actions/systemSetting/newRole';
import tCallingNumberActions from 'Actions/systemSetting/callingNumber';

const {ModalSize} = modal;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 3}, wrapperCol: {span: 21}};
const {SHOW_PARENT} = TreeSelect;
class NewRole extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      permitTree: [],
      checkedList: [],
      editLoading: false,
      collapseList:[],
    };
    this.itemHandle = this.itemHandle.bind(this);
  }

  componentDidMount() {
    const {
      // newRoleData,
      newRoleData: {permitTree, checkedList},
      callNactions,
    } = this.props;
    const user = window.localStorage.getItem('user') || '{}';
    const vccId = JSON.parse(user).profile?.vcc_id;
    callNactions.queryDeptTree(vccId);
    
    permitTree.forEach(item=>{
      this.setCollapseList(item);
    })

    this.setState(
      {
        permitTree: [
          {
            name: '所有权限',
            id: 100,
            children: permitTree,
          },
        ],
        checkedList,
      },
      () => {
        this.authTreeFun();
      },
    );
  }

  // 挂载选中
  authTreeFun() {
    const {checkedList} = this.state;
    checkedList.forEach(item => {
      this.itemHandle(item, 'first');
    });
  }

  // 展开手风琴
  setCollapseList(item){
    const { collapseList} = this.state;
    if((collapseList.indexOf(item.id.toString()) === -1)){
      collapseList.push(item.id.toString());
      this.setState({ collapseList});
    }

  };

  // 四级联动
  itemHandle(id, isFirst, checked = true) {
    const {permitTree} = this.state;
    const tree = [...permitTree];
    tree.forEach(item1 => {
      if (item1.id === id) {
        item1.checked = checked;
        item1.indeterminate = false;
        if (item1.children) {
          item1.children.forEach(item2 => {
            item2.checked = checked;
            item2.indeterminate = false;
            // if(isFirst === 'first'){
            //   this.setCollapseList(item2);
            // }
            if (item2.children) {
              item2.children.forEach(item3 => {
                item3.checked = checked;
                item3.indeterminate = false;

                if (item3.children) {
                  item3.children.forEach(item4 => {
                    item4.checked = checked;
                    item4.indeterminate = false;
                  });
                }
              });
            }
          });
        }
      } else {
        // 反向思路: 保存子选项框的个数, 子选项选中就-1, 等于0说明都选中了, 父选项就勾上
        let temp1 = item1.children.length;
        let tempindeter1 = 0;
        item1.children.forEach(item2 => {
          // if(isFirst === 'first'){
          //     this.setCollapseList(item2);
          //   }
          if (item2.id === id) {
            item2.checked = checked;
            item2.indeterminate = false;
            if (item2.children) {
              item2.children.forEach(item3 => {
                item3.checked = checked;
                item3.indeterminate = false;

                if (item3.children) {
                  item3.children.forEach(item4 => {
                    item4.checked = checked;
                    item4.indeterminate = false;
                  });
                }
              });
            }
          } else {
            let temp2 = item2.children.length;
            let tempindeter2 = 0;
            item2.children.forEach(item3 => {
              if (item3.id === id) {
                item3.checked = checked;
                item3.indeterminate = false;

                if (item3.children) {
                  item3.children.forEach(item4 => {
                    item4.checked = checked;
                    item4.indeterminate = false;
                  });
                }
              } else {
                let temp3 = item3.children.length;
                item3.children.forEach(item4 => {
                  if (item4.id === id) {
                    item4.checked = checked;
                    item4.indeterminate = false;
                  }
                  temp3 = item4.checked ? temp3 - 1 : temp3;
                });
                item3.indeterminate =
                  item3.children.length > temp3 && temp3 > 0;
                  item3.checked = temp3 === 0;
              }
              temp2 = item3.checked ? temp2 - 1 : temp2;
              tempindeter2 = item3.indeterminate ? tempindeter2 + 1 : tempindeter2;
            });
            item2.checked = temp2 === 0;
            item2.indeterminate = tempindeter2 > 0 || (temp2>0 && temp2<item2.children.length);
            // if(isFirst === 'first'){
            //   this.setCollapseList(item2);
            // }
          }
          //  选中-1, 未选中不动
          temp1 = item2.checked ? temp1 - 1 : temp1;
          tempindeter1 = item2.indeterminate ? tempindeter1 + 1 : tempindeter1;

        });
        //  长度是0, 父选项框就勾选
        item1.checked = temp1 === 0;
        item1.indeterminate = tempindeter1 > 0  || (temp1>0 && temp1<item1.children.length);
      }
    });

    this.setState(
      {
        permitTree: [...tree],
      },
      () => {
        const {permitTree} = this.state;
      },
    );
  }

  // 点击确定
  handleSubmit = () => {
        const {
          roleEditData: {roleId} = {},
          pageStatus,
          searchData = {name: ''},
          form: {validateFields},
          getTableList,
          setNewRoleVisible,
          actions,
        } = this.props;
        setNewRoleVisible();
        const {permitTree} = this.state;
        this.setState({
          editLoading: false,
        });
        const permitIds = [];
        permitTree[0].children.map(v => {
          v.children.map(v2 => {
            v2.children.map(v3 => {
              if (v3.checked) {
                permitIds.push(v3.id);
              }
              return v3;
            });
            return v2;
          });
          return v;
        });
        validateFields((err, values) => {
          if (!err) {
            const params = {
              ...values,
              roleId: roleId || '',
              deptIds: values.deptselect,
              permitIds: permitIds || [],
            };
            this.setState({
              editLoading: true,
            });
            actions
              .setNewRole(params)
              .then(res => {
                const {payload: {code} = {}} = res || {};
    
                if (parseInt(code, 10) === 200) {
                  message.success('操作成功！');
                  getTableList({...pageStatus, ...searchData});
                }
              })
              .finally(() => {
                this.setState({
                  editLoading: false,
                });
              });
          }
        });
        
      
    
    
  };

  callback = (key) => {
    this.setState({collapseList: key},()=>{
      const {collapseList} = this.state;
    })
  }


  render() {
    const {
      roleEditData: {roleId = '', name = '', desc = '', deptselect = []},

      newRoleData: {checkedList = []} = {},
      form: {resetFields, getFieldDecorator},
      setNewRoleVisible,
      treeData,
    } = this.props;
    const {Panel} = Collapse;
    const {permitTree, editLoading, collapseList} = this.state;
    let authTreeMap = [];
    if (permitTree[0]) {
      authTreeMap = permitTree[0].children.map(item1 => (
        // 手风琴
        <Panel
          key={item1.id.toString()}
          header={
            <span
              onClick={e => {
                e.stopPropagation();
              }}>
              {/* 一级复选框(向下操控二级三级) */}
              <Checkbox
                name={item1.id.toString()}
                checked={item1.checked}
                indeterminate={item1.indeterminate}
                onClick={e => {
                  this.itemHandle(parseInt(e.target.name, 0), 'not', e.target.checked);
                }}>
                {item1.name}
              </Checkbox>
            </span>
          }>
          {/* 二级复选框(向下操控三级,向上联动一级) */}
          {item1.children.map((item2, index) => (
            <div
              className="out"
              key={item2.id.toString()}
              style={
                index === item1.children.length - 1
                  ? {}
                  : {borderBottom: '1px solid #d8e0e3'}
              }>
              <span className="innerLeft">
                <Checkbox
                  name={item2.id.toString()}
                  checked={item2.checked}
                  indeterminate={item2.indeterminate}
                  onClick={e => {
                    this.itemHandle(
                      parseInt(e.target.name, 0),
                      'not',
                      e.target.checked,
                    );
                  }}>
                  {item2.name}
                </Checkbox>
              </span>

              {/* 三级复选框(向上联动二级一级) */}
              <span
                style={{
                  padding: 16,
                  paddingBottom: 1,
                  width: '80%',
                  borderLeft: '1px solid #d8e0e3',
                  display: 'inline-block',
                  marginLeft: '20%',
                }}>
                {item2.children.map(item3 => (
                  <Checkbox
                    style={{width: '30%', marginLeft: 0, marginBottom: 15}}
                    key={item3.id.toString()}
                    name={item3.id.toString()}
                    checked={item3.checked}
                    onClick={e => {
                      this.itemHandle(
                        parseInt(e.target.name, 0),
                        'not',
                        e.target.checked,
                      );
                    }}>
                    {item3.name}
                  </Checkbox>
                ))}
              </span>
            </div>
          ))}
        </Panel>
      ));
    }

    return (
      <ModalSize
        width={800}
        title={`${roleId ? '编辑' : '新增'}角色`}
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={setNewRoleVisible}
        editLoading={editLoading}
        afterClose={() => {
          resetFields();
        }}>
        <Form>
          <FormItem {...formItemLayout} label="角色名称: ">
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: '角色名称不得为空！',
                },
              ],
            })(<Input placeholder="请输入角色名称" maxLength="150" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="角色描述: ">
            {getFieldDecorator('desc', {
              initialValue: desc,
            })(<Input.TextArea placeholder="请输入角色描述内容" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="角色权限: ">
            {getFieldDecorator('checkedList', {
              initialValue: checkedList || [],
            })(
              <div className="newRole">
                <Checkbox
                  style={{marginBottom: 10}}
                  key={permitTree[0]?.id.toString()}
                  name={permitTree[0]?.id.toString()}
                  checked={permitTree[0]?.checked}
                  indeterminate={permitTree[0]?.indeterminate}
                  onClick={e => {
                    this.itemHandle(
                      parseInt(e.target.name, 0),
                      'not',
                      e.target.checked,
                    );
                  }}>
                  {permitTree[0]?.name}
                </Checkbox>
                <Collapse activeKey={collapseList} onChange={this.callback} expandIconPosition="right">{authTreeMap}</Collapse>
              </div>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="部门权限: ">
            {getFieldDecorator('deptselect', {
              initialValue: deptselect,
            })(
              <TreeSelect
                style={{width: '100%'}}
                dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                treeData={treeData}
                placeholder="请选择部门权限"
                onChange={this.onChange}
                allowClear
                multiple
                treeDefaultExpandAll={false}
              />,
            )}
          </FormItem>
        </Form>
      </ModalSize>
    );
  }
}

const mapStateToProps = ({
  systemSettingNewRole,
  systemSettingCallingNumber,
}) => ({
  newRoleData: systemSettingNewRole.newRoleData,
  pageStatus: systemSettingNewRole.pageStatus,
  treeData: systemSettingCallingNumber.treeData,
});

const mapDispatchToProps = dispatch => ({
  callNactions: bindActionCreators(tCallingNumberActions, dispatch),
  actions: bindActionCreators(newRoleActions, dispatch),
});

const NewRoleWrap = Form.create()(NewRole);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewRoleWrap);
